import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { displayAsMoney } from '../../../util/helpers/Numbers';

export default class TotalBudgetInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const budgetValue = e.target.value.replace(/\D/g, '');
    this.props.updateBudget(budgetValue);
  }

  render() {
    return (
      <FormGroup>
        <ControlLabel>Total Budget</ControlLabel>
        <FormControl
          type='text'
          value={displayAsMoney(this.props.totalBudget)}
          onChange={this.onChange}
          className='budget-input'
        />
      </FormGroup>
    );
  }
}

TotalBudgetInput.propTypes = {
  totalBudget: PropTypes.number,
  updateBudget: PropTypes.func,
};
